document.addEventListener('DOMContentLoaded', () => {
  const config = document.querySelector('[data-sn-config]')?.dataset;
  if (!config) return;
  const root = config.root.replace(/\/$/, '') + '/';
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
  const money = cents => 'NZ$' + (cents / 100).toLocaleString('en-NZ', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  document.querySelectorAll('[data-sn-base]').forEach(form => {
    const updateTotal = () => {
      const output = form.querySelector('[data-sn-selection-total]');
      if (output) output.textContent = config.selectionTotal + ': ' + money(Number(form.dataset.snBase) + [...form.querySelectorAll('[data-sn-extra]:checked')].reduce((sum, el) => sum + Number(el.dataset.price), 0));
    };
    form.addEventListener('change', updateTotal); updateTotal();
  });
  let busy = false;
  const request = async (path, payload) => {
    const response = await fetch(root + path, {method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: {'Accept': 'application/json', ...(payload ? {'Content-Type': 'application/json'} : {})}, ...(payload ? {body: JSON.stringify(payload)} : {})});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : config.error);
    return data;
  };
  const cart = async () => {
    const current = await request('cart.js');
    if (current.currency !== 'NZD' || !Array.isArray(current.items)) throw new Error(config.currencyError);
    return current;
  };
  const mutate = async (form, action) => {
    if (busy) return;
    busy = true;
    const controls = [...document.querySelectorAll('[data-sn-add] button, [data-sn-add] input[type=checkbox], [data-sn-change] button, [data-sn-change] input[type=number], [data-sn-checkout]')];
    const previous = controls.map(el => el.disabled);
    const submit = form.querySelector('button[type=submit]');
    const submitText = submit?.textContent;
    if (submit) submit.textContent = form.matches('[data-sn-add]') ? config.adding : config.updating;
    controls.forEach(el => el.disabled = true);
    form.setAttribute('aria-busy', 'true');
    const error = form.querySelector('[data-sn-error]');
    const review = form.querySelector('[data-sn-review]');
    if (error) error.hidden = true;
    if (review) review.hidden = true;
    try {
      await action(await cart());
      location.assign(config.cart);
    } catch (reason) {
      if (error) { error.textContent = reason.message || config.error; error.hidden = false; error.tabIndex = -1; error.focus(); }
      if (review) review.hidden = false;
      controls.forEach((el, i) => el.disabled = previous[i]);
      if (submit) submit.textContent = submitText;

      form.removeAttribute('aria-busy'); busy = false;
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (busy) { event.preventDefault(); return; }
    if (form.matches('[data-sn-add]')) {
      event.preventDefault();
      const id = Number(form.elements['items[0][id]'].value);
      const extras = [...form.querySelectorAll('[data-sn-extra]:checked')];
      mutate(form, async current => {
        if (form.dataset.snOffer === 'true' && current.items.some(item => item.variant_id === id)) return;
        const properties = Object.fromEntries([...form.querySelectorAll('[data-sn-property]')].map(input => [input.dataset.propertyName, input.value]));
        const items = [{id, quantity: 1, ...(Object.keys(properties).length ? {properties} : {})}];
        if (form.dataset.snWood === 'true') extras.forEach(extra => { if (!current.items.some(item => item.variant_id === Number(extra.value))) items.push({id: Number(extra.value), quantity: 1}); });
        await request('cart/add.js', {items});
      });
    } else if (form.matches('[data-sn-change]')) {
      event.preventDefault();
      const quantity = Number(form.elements.quantity.value), id = form.elements.id.value;
      if (!Number.isInteger(quantity) || quantity < 0) { form.reportValidity(); return; }
      mutate(form, async current => {
        if (!current.items.some(item => item.key === id)) throw new Error(config.error);
        await request('cart/change.js', {id, quantity});
      });
    }
  });
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-sn-remove]');
    if (!remove) return;
    event.preventDefault();
    const form = remove.closest('form'), id = form.elements.id.value;
    mutate(form, async current => {
      if (!current.items.some(item => item.key === id)) throw new Error(config.error);
      await request('cart/change.js', {id, quantity: 0});
    });
  });
});

